import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_SUPPLY_ORDER } from "config/connString";

const checkDuplicatedSupplyRequest = createAsyncThunk(
  "supply-orders/check-duplicated-supply-request",
  async (data) => {
    const { inventoryItemIds, ...rest } = data;
    const inventoryItemIdsQuery = inventoryItemIds
      ?.map((id) => `inventoryItemIds=${id}`)
      .join("&");

    try {
      const api = useAxios();
      const response = await api.get(
        `${URL_SUPPLY_ORDER}/check-supply-request-exists?${inventoryItemIdsQuery}`,
        {
          params: rest,
        }
      );
      return response.data;
    } catch (error) {
      if (error?.status === 409) {
        return { statusCode: 409, data: error?.response?.data?.data };
      }
      if (error?.status === 400) {
        return { statusCode: 400, data: null };
      }
    }
  }
);

export { checkDuplicatedSupplyRequest };
